import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["customTag", "label"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { INPUT_SIZES } from "../constants";
import { truncateText, typographyGroupLabel } from "./../../core";
import { jsx as _jsx } from "react/jsx-runtime";
var StyledInputLabel = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  box-sizing: border-box;\n  pointer-events: none;\n  width: 100%;\n  ", "\n  ", "\n    ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return typographyGroupLabel(theme);
}, truncateText, function (_ref2) {
  var isDisabled = _ref2.isDisabled,
      isFocused = _ref2.isFocused,
      theme = _ref2.theme;
  return isFocused && !isDisabled && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), theme.color.primary['500'].value);
}, function (_ref3) {
  var hasError = _ref3.hasError,
      isDisabled = _ref3.isDisabled,
      theme = _ref3.theme;
  return hasError && !isDisabled && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), theme.color.system.negative[500].value);
}, function (_ref4) {
  var isReadOnly = _ref4.isReadOnly,
      theme = _ref4.theme;
  return isReadOnly && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      color: ", ";\n    "])), theme.color.text.light.secondary.value);
});
var InputLabel = styled(function (_ref5) {
  var customTag = _ref5.customTag,
      label = _ref5.label,
      other = _objectWithoutProperties(_ref5, _excluded);

  return /*#__PURE__*/_jsx(StyledInputLabel, _objectSpread(_objectSpread({
    as: customTag
  }, other), {}, {
    children: label
  }));
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([""])));
InputLabel.propTypes = {
  /** Replaces the default tag with a new tag */
  customTag: PropTypes.elementType,

  /** If true, adjusts label styling */
  hasError: PropTypes.bool,

  /** If true, adjusts label styling */
  isDisabled: PropTypes.bool,

  /** If true, label has focus */
  isFocused: PropTypes.bool,

  /** If true, adjusts label styling */
  isReadOnly: PropTypes.bool,

  /** If true, adds required symbol at the end of label */
  isRequired: PropTypes.bool,

  /** Label of the input field */
  label: PropTypes.node.isRequired,

  /** Size of base input label */
  size: PropTypes.oneOf(Object.values(INPUT_SIZES))
};
InputLabel.defaultProps = {
  customTag: undefined,
  hasError: false,
  isDisabled: false,
  isFocused: false,
  isReadOnly: false,
  isRequired: false,
  size: INPUT_SIZES.STANDARD
};
export { InputLabel };